import { Injector } from '@angular/core';
import { PlatformService } from '../platform.service';
import { AndroidRtcService } from './android-rtc.service';
import { RtcService } from './rtc.service';
import { WebRtcService } from './web-rtc.service';

export const rtcFactory = (platform: PlatformService, injector: Injector): RtcService => {
  if (platform.isAndroid()) {
    return new AndroidRtcService(injector);
  }
  return new WebRtcService(injector);
};
